const mediaCards = [
  {
    title: '本周最热电影推荐',
    desc: '精选五部豆瓣高分新片，从悬疑到喜剧，每一部都值得你花时间。极速影视已全部上线高清版本，免广告流畅播放。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20scene%20collage%20with%20warm%20cinema%20lighting%2C%20film%20poster%20style%2C%20dramatic%20composition%2C%20soft%20shadows%2C%20deep%20red%20and%20golden%20accents%2C%20movie%20theater%20atmosphere%2C%20elegant%20cinematic%20photography%2C%20no%20text%20or%20logos&width=800&height=500&seq=media-movie-2026-01&orientation=landscape',
    tag: '电影精选',
  },
  {
    title: '暑期档热播剧追更指南',
    desc: '全网热播电视剧追剧日历一览，极速影视每日同步更新最新剧集，让你不错过任何精彩剧情，高清画质追剧更过瘾。',
    img: 'https://readdy.ai/api/search-image?query=TV%20series%20drama%20scene%20with%20warm%20living%20room%20setting%2C%20cozy%20atmosphere%2C%20soft%20amber%20lighting%2C%20cinematic%20composition%2C%20television%20aesthetic%2C%20warm%20tones%2C%20artistic%20photography%2C%20no%20text&width=800&height=500&seq=media-tv-2026-02&orientation=landscape',
    tag: '追剧日历',
  },
  {
    title: '热门综艺节目单速览',
    desc: '音乐竞演、户外真人秀、脱口秀……极速影视综艺频道汇聚全网最热节目，高清不卡顿，周末宅家一口气看个够。',
    img: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20with%20colorful%20lighting%2C%20warm%20spotlights%2C%20entertainment%20atmosphere%2C%20vibrant%20yet%20elegant%20composition%2C%20golden%20and%20crimson%20stage%20lights%2C%20artistic%20photography%2C%20no%20text%20or%20people&width=800&height=500&seq=media-variety-2026-03&orientation=landscape',
    tag: '综艺看点',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            精彩推荐
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto leading-relaxed">
            编辑精心挑选的影视专题，帮你发现好内容
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaCards.map((card, i) => (
            <article
              key={i}
              className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer transition-all hover:-translate-y-1"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                  {card.tag}
                </span>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-1">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}